import { db, requestPermission } from 'src/db'
import { firestoreAction } from 'vuexfire'

export default {
	namespaced: true,
	state: {
		userClaims: null,
		campaigns: [],
		prospects: [],
		fcmToken: '',
		convos: null,
		groupconvos: null,
		messages: [],
		grpmessages: [],
		mails: [],
		phones:[],
		user: null,
		teams:[],
		emails:null,
		calls:null,
		extensionuuid:null,
		search:'',
		searchProspects: [],
		unreadCount:0,
		starredCount:0,
		autoPilotCount:0,
		feedbackCount:0,
		erroredCount:0,
		scheduledCount:0,
	},
	mutations: {
		SET(state, payload) {
			switch (payload.var) {
				case 'fcmToken': state.fcmToken = payload.val;
					break;
				case 'userClaims': state.userClaims = payload.val;
					break;
				case 'search':state.search = payload.val;
				break;
				case 'searchProspects':state.searchProspects = payload.val;
				break;
				case 'searchConvo':state.convos = payload.val;
				break;
				case 'convos':state.convos = payload.val;
				break;
			}
		},
		SET_CONVOS_COUNT(state, count) {
			state.convosCount = count;
		},
		SET_CAMP_COUNT(state, count) {
			state.campCount = count;
		},
		SET_ERRORED_CONVO_COUNT(state, count) {
			state.erroredCount = count;
		},
		SET_FEEDBACK_CONVO_COUNT(state, count) {
			state.feedbackCount = count;
		},
		SET_UNREAD_CONVO_COUNT(state, count) {
			state.unreadCount = count;
		},
		SET_AUTO_CONVO_COUNT(state, count) {
			state.autoPilotCount = count;
		},
		SET_SCHEDULE_CONVO_COUNT(state, count) {
			state.scheduledCount = count;
		},
		SET_STARRED_CONVO_COUNT(state, count) {
			state.starredCount = count;
		},
		CLEAR_ALL(state) {
			state.fcmToken = '';
			state.user = null;
			state.messages = [];
			state.grpmessages = [];
			state.mails = [];
			state.phones = [];
			state.convos = null;
			state.groupconvos = null;
			state.prospects = [];
			state.campaigns = [];
			state.userClaims = null;
			state.teams = [];
			state.emails = null;
			state.calls = null;
			state.extensionuuid=null
		},
		CLEAR_MAILS(state) {
			state.mails = [];
			state.emails = null;
		},
		CLEAR_ONLY_MAILS(state) {
			state.mails = [];
		},
		CLEAR_CALLS(state) {
			state.phones = [];
			state.calls = null;
		},
		CLEAR_ONLY_PHONES(state) {
			state.phones = [];
		},
		CLEAR_ONLY_CONVO(state) {
			state.convos = [];
		},
		CLEAR_ONLY_PROSPECT(state) {
			state.prospects = [];
		},
	},
	actions: {
		async searchCollection({ commit,state }) {
			if (state.search.trim()) {
				// eslint-disable-next-line
				console.log(state.search);
				var s = state.search;

				return db.collection('Users').where('Uid', '==', 'B2ZK14pbXwPIyDDg7iGZw1UQaw03').get().then(querySnap => {
					
					let pid = querySnap.docs[0].id;	

					// Search in the 'First' field
					var firstSearch = db.collection(`Users/${pid}/Prospects`)
						.where('First', '>=', s)
						.where('First', '<=', s + '\uf8ff');
				
					// Search in the 'Last' field
					var lastSearch = db.collection(`Users/${pid}/Prospects`)
						.where('Last', '>=', s)
						.where('Last', '<=', s + '\uf8ff');
		
						return Promise.all([firstSearch.get(), lastSearch.get()])
						.then(([firstQuerySnapshot, lastQuerySnapshot]) => {
							let results = [];
							
							// Add results from 'First' search
							firstQuerySnapshot.forEach(doc => {
								results.push({
								...doc.data(), // Include all document fields
								id: doc.id,    // Add document ID
								});
							});
		
							// Add results from 'Last' search, but avoid duplicates
							lastQuerySnapshot.forEach(doc => {
								// Only add if not already included
								if (!results.some(item => item.id === doc.id)) {
									results.push({
									...doc.data(), // Include all document fields
									id: doc.id,    // Add document ID
									});
								}
							});
							
							// eslint-disable-next-line
							console.log('Combined Results:', results);
							
							commit('SET', { var: 'searchProspects', val: results });
							
							return results;
						})
						.catch(error => {
							// eslint-disable-next-line
							console.error('Error executing queries:', error);
							return [];
						});
				})

			}
		},
		async fetchFcmToken(context, payload) {
			try {
				let token = await requestPermission();
				context.commit('SET', {var: 'fcmToken', val: token});
				if (!payload.user.fcmTokens) { payload.user.fcmTokens = {}; }
				if (token && payload.user.fcmTokens[token] != true) {
					payload.user.fcmTokens[token] = true;
					db.doc(`Users/${payload.id}`).set(payload.user);
				}
			} catch (err) {
				// eslint-disable-next-line
				console.error(err);
			}
		},
		setExtensionUUID : firestoreAction(({bindFirestoreRef},exid)=>{
			return bindFirestoreRef('extensionuuid',exid);
		}),
		rebindConvos: firestoreAction(({ bindFirestoreRef }, uid) => {
			let p4 = bindFirestoreRef('convos', db.collection('Conversations')
				.where('Uid', '==', uid).orderBy('DateUpdated', 'desc'));
			return Promise.all([p4]);
		}),
		rebindProspects: firestoreAction(({ bindFirestoreRef }, pid) => {
			let p2 = bindFirestoreRef('prospects', db.collection(`Users/${pid}/Prospects`));
			return Promise.all([p2]);
		}),
		rebindConvosNew: firestoreAction(async ({ bindFirestoreRef }, { uid, page, limit }) => {
			if (!uid) {
				throw new Error("UID is required for rebindConvosNew");
			}
		
			// Get reference to the collection and apply the limit
			const conversationsRef = db.collection('Conversations')
				.where('Uid', '==', uid)
				.orderBy('DateUpdated', 'desc');
		
			// Calculate the starting point for the page
			let query = conversationsRef.limit(limit);
		
			// For pages beyond the first, fetch the starting point
			if (page > 1) {
				const offset = (page - 1) * limit;
		
				// Get the last document of the previous page
				const snapshot = await conversationsRef.limit(offset).get();
		
				if (!snapshot.empty) {
					const lastDoc = snapshot.docs[snapshot.docs.length - 1];
					query = conversationsRef.startAfter(lastDoc).limit(limit);
				} else {
					throw new Error("No data found for the requested page.");
				}
			}
		
			// Bind the query to the 'convos' store state
			return bindFirestoreRef('convos', query);
		}),
		rebindOldestConvos: firestoreAction(async ({ bindFirestoreRef }, { uid, page, limit }) => {
			if (!uid) {
				throw new Error("UID is required for rebindOldestConvos");
			}
		
			// Get reference to the collection and apply the limit
			const conversationsRef = db.collection('Conversations')
				.where('Uid', '==', uid)
				.orderBy('DateUpdated', 'asc');
		
			// Calculate the starting point for the page
			let query = conversationsRef.limit(limit);
		
			// For pages beyond the first, fetch the starting point
			if (page > 1) {
				const offset = (page - 1) * limit;
		
				// Get the last document of the previous page
				const snapshot = await conversationsRef.limit(offset).get();
		
				if (!snapshot.empty) {
					const lastDoc = snapshot.docs[snapshot.docs.length - 1];
					query = conversationsRef.startAfter(lastDoc).limit(limit);
				} else {
					throw new Error("No data found for the requested page.");
				}
			}
		
			// Bind the query to the 'convos' store state
			return bindFirestoreRef('convos', query);
		}),	
		rebindConvosCountOld: firestoreAction(async ({ commit }, {uid, id}) => {
			if (!uid || !id) {
				throw new Error('UID is undefined or null in rebindConvosCount action');
			}
			
			const querySnapshot = await db.collection('Conversations')
				.where('Uid', '==', uid)
				.orderBy('DateUpdated', 'desc')
				.get();
			
			const conversationsRef = await db.collection("Conversations")
				.where("Uid", "==", uid)
				.where("Errors", ">", 0)
				.orderBy("Errors", "desc")
				.orderBy("DateUpdated", "desc")
				.get();
			
			const conversationsRefFeedBack = await db.collection("Conversations")
				.where("Uid", "==", uid)
				.where("needHumanFeedback", "==", true)
				.orderBy("needHumanFeedback", "desc")
				.orderBy("DateUpdated", "desc")
				.get();
			
			const conversationsRefUnread =await db.collection("Conversations")
				.where("Uid", "==", uid)
				.where("Unread", ">", 0)
				.orderBy("Unread", "desc")
				.orderBy("DateUpdated", "desc")
				.get();
			
			const conversationsRefAuto = await db.collection("Conversations")
				.where("Uid", "==", uid)
				.where("autoSms", "==", true)
				.orderBy("autoSms", "desc")
				.orderBy("DateUpdated", "desc")
				.get();

			const conversationsRefScheduled = await db.collection("Conversations")
				.where('Uid', '==', uid)
				.where('ScheduledCount', '>', 0)
				.orderBy('ScheduledCount', 'desc')
				.orderBy('DateUpdated', 'desc')
				.get();

			const prospectsSnapshot = await db.collection(`Users/${id}/Prospects`)
				.where('Starred', '==', true)
				.get();
			
			commit('SET_CONVOS_COUNT', querySnapshot.size);
			commit('SET_ERRORED_CONVO_COUNT', conversationsRef.size);
			commit('SET_FEEDBACK_CONVO_COUNT', conversationsRefFeedBack.size);
			commit('SET_UNREAD_CONVO_COUNT', conversationsRefUnread.size);
			commit('SET_AUTO_CONVO_COUNT', conversationsRefAuto.size);
			commit('SET_SCHEDULE_CONVO_COUNT', conversationsRefScheduled.size);
			commit('SET_STARRED_CONVO_COUNT', prospectsSnapshot.size);

			if (!querySnapshot.empty) {
				const lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];
				const lastDocDate = lastDoc.data().DateUpdated;
		
				// eslint-disable-next-line
				console.log('Last document date:', lastDocDate);
		
				// Return the last document date if needed
				return lastDocDate;
			} else {
				// eslint-disable-next-line
				console.log('No documents found.');
				return null;
			}
		}),
		rebindConvosCount: firestoreAction(async ({ commit }, { uid, id }) => {
			if (!uid || !id) {
				throw new Error('UID is undefined or null in rebindConvosCount action');
			}
		
			try {
				const queries = {
					allConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.orderBy('DateUpdated', 'desc'),
		
					erroredConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('Errors', '>', 0)
						.orderBy('Errors', 'desc')
						.orderBy('DateUpdated', 'desc'),
		
					feedbackConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('needHumanFeedback', '==', true)
						.orderBy('needHumanFeedback', 'desc')
						.orderBy('DateUpdated', 'desc'),
		
					unreadConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('Unread', '>', 0)
						.orderBy('Unread', 'desc')
						.orderBy('DateUpdated', 'desc'),
		
					autoConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('autoSms', '==', true)
						.orderBy('autoSms', 'desc')
						.orderBy('DateUpdated', 'desc'),
		
					scheduledConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('ScheduledCount', '>', 0)
						.orderBy('ScheduledCount', 'desc')
						.orderBy('DateUpdated', 'desc'),
		
					starredProspects: db.collection(`Users/${id}/Prospects`)
						.where('Starred', '==', true)
				};
		
				// Execute queries concurrently
				const [
					allConversationsSnapshot,
					erroredConversationsSnapshot,
					feedbackConversationsSnapshot,
					unreadConversationsSnapshot,
					autoConversationsSnapshot,
					scheduledConversationsSnapshot,
					starredProspectsSnapshot
				] = await Promise.all([
					queries.allConversations.get(),
					queries.erroredConversations.get(),
					queries.feedbackConversations.get(),
					queries.unreadConversations.get(),
					queries.autoConversations.get(),
					queries.scheduledConversations.get(),
					queries.starredProspects.get()
				]);
		
				// Commit counts to the state
				commit('SET_CONVOS_COUNT', allConversationsSnapshot.size);
				commit('SET_ERRORED_CONVO_COUNT', erroredConversationsSnapshot.size);
				commit('SET_FEEDBACK_CONVO_COUNT', feedbackConversationsSnapshot.size);
				commit('SET_UNREAD_CONVO_COUNT', unreadConversationsSnapshot.size);
				commit('SET_AUTO_CONVO_COUNT', autoConversationsSnapshot.size);
				commit('SET_SCHEDULE_CONVO_COUNT', scheduledConversationsSnapshot.size);
				commit('SET_STARRED_CONVO_COUNT', starredProspectsSnapshot.size);
		
				// Handle last document date
				if (!allConversationsSnapshot.empty) {
					const lastDoc = allConversationsSnapshot.docs[allConversationsSnapshot.docs.length - 1];
					const lastDocDate = lastDoc.data().DateUpdated;
					
					//eslint-disable-next-line
					console.log('Last document date:', lastDocDate);
					return lastDocDate;
				} else {
					//eslint-disable-next-line
					console.log('No documents found.');
					return null;
				}
			} catch (error) {
				//eslint-disable-next-line
				console.error('Error in rebindConvosCount:', error);
				throw error;
			}
		}),
		rebindConvosUnreadCount: firestoreAction(async ({ commit }, { uid, id }) => {
			if (!uid || !id) {
				throw new Error('UID is undefined or null in rebindConvosCount action');
			}
		
			try {
				const queries = {		
					unreadConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('Unread', '>', 0)
						.orderBy('Unread', 'desc')
						.orderBy('DateUpdated', 'desc')
				};
		
				// Execute queries concurrently
				const [
					unreadConversationsSnapshot
				] = await Promise.all([
					queries.unreadConversations.get()
				]);
		
				// Commit counts to the state
				commit('SET_UNREAD_CONVO_COUNT', unreadConversationsSnapshot.size);
			} catch (error) {
				//eslint-disable-next-line
				console.error('Error in rebindConvosCount:', error);
				throw error;
			}
		}),
		rebindConvosDueTasksCount: firestoreAction(async ({ commit }, { uid, id }) => {
			if (!uid || !id) {
				throw new Error('UID is undefined or null in rebindConvosCount action');
			}
		
			try {
				const queries = {		
					unreadConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('Unread', '>', 0)
						.orderBy('Unread', 'desc')
						.orderBy('DateUpdated', 'desc')
				};
		
				// Execute queries concurrently
				const [
					unreadConversationsSnapshot
				] = await Promise.all([
					queries.unreadConversations.get()
				]);
		
				// Commit counts to the state
				commit('SET_UNREAD_CONVO_COUNT', unreadConversationsSnapshot.size);
			} catch (error) {
				//eslint-disable-next-line
				console.error('Error in rebindConvosCount:', error);
				throw error;
			}
		}),
		rebindConvosStarredCount: firestoreAction(async ({ commit }, { uid, id }) => {
			if (!uid || !id) {
				throw new Error('UID is undefined or null in rebindConvosCount action');
			}
		
			try {
				const queries = {		
					starredProspects: db.collection(`Users/${id}/Prospects`)
						.where('Starred', '==', true)
				};
		
				const [
					starredProspectsSnapshot
				] = await Promise.all([
					queries.starredProspects.get()
				]);
		
				commit('SET_STARRED_CONVO_COUNT', starredProspectsSnapshot.size);
			} catch (error) {
				//eslint-disable-next-line
				console.error('Error in rebindConvosStarredCount:', error);
				throw error;
			}
		}),
		rebindConvosAutopilotCount: firestoreAction(async ({ commit }, { uid, id }) => {
			if (!uid || !id) {
				throw new Error('UID is undefined or null in rebindConvosCount action');
			}
		
			try {
				const queries = {		
					autoConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('autoSms', '==', true)
						.orderBy('autoSms', 'desc')
						.orderBy('DateUpdated', 'desc'),
				};
		
				const [
					autoConversationsSnapshot,
				] = await Promise.all([
					queries.autoConversations.get(),
				]);
		
		
				commit('SET_AUTO_CONVO_COUNT', autoConversationsSnapshot.size);
			} catch (error) {
				//eslint-disable-next-line
				console.error('Error in rebindConvosAutopilotCount:', error);
				throw error;
			}
		}),
		rebindConvosFeedbackCount: firestoreAction(async ({ commit }, { uid, id }) => {
			if (!uid || !id) {
				throw new Error('UID is undefined or null in rebindConvosCount action');
			}
		
			try {
				const queries = {		
					feedbackConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('needHumanFeedback', '==', true)
						.orderBy('needHumanFeedback', 'desc')
						.orderBy('DateUpdated', 'desc'),
				};
		
				const [
					feedbackConversationsSnapshot,
				] = await Promise.all([
					queries.feedbackConversations.get(),
				]);
		
		
				commit('SET_FEEDBACK_CONVO_COUNT', feedbackConversationsSnapshot.size);
			} catch (error) {
				//eslint-disable-next-line
				console.error('Error in rebindConvosFeedbackCount:', error);
				throw error;
			}
		}),
		rebindConvosErroredCount: firestoreAction(async ({ commit }, { uid, id }) => {
			if (!uid || !id) {
				throw new Error('UID is undefined or null in rebindConvosCount action');
			}
		
			try {
				const queries = {		
					erroredConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('Errors', '>', 0)
						.orderBy('Errors', 'desc')
						.orderBy('DateUpdated', 'desc'),
				};
		
				const [
					erroredConversationsSnapshot,
				] = await Promise.all([
					queries.erroredConversations.get(),
				]);
		
		
				commit('SET_ERRORED_CONVO_COUNT', erroredConversationsSnapshot.size);
			} catch (error) {
				//eslint-disable-next-line
				console.error('Error in rebindConvosErroredCount:', error);
				throw error;
			}
		}),
		rebindConvosScheduledCount: firestoreAction(async ({ commit }, { uid, id }) => {
			if (!uid || !id) {
				throw new Error('UID is undefined or null in rebindConvosCount action');
			}
		
			try {
				const queries = {		
					scheduledConversations: db.collection('Conversations')
						.where('Uid', '==', uid)
						.where('ScheduledCount', '>', 0)
						.orderBy('ScheduledCount', 'desc')
						.orderBy('DateUpdated', 'desc'),
				};
		
				const [
					scheduledConversationsSnapshot,
				] = await Promise.all([
					queries.scheduledConversations.get(),
				]);
		
				commit('SET_SCHEDULE_CONVO_COUNT', scheduledConversationsSnapshot.size);
			} catch (error) {
				//eslint-disable-next-line
				console.error('Error in rebindConvosScheduledCount:', error);
				throw error;
			}
		}),
		erroredConvos: firestoreAction(async ({ bindFirestoreRef }, { uid, limit, page }) => {
			if (!uid) {
				throw new Error("UID is required for scheduledConvos");
			}
			const conversationsRef = db.collection("Conversations")
					.where("Uid", "==", uid)
					.where("Errors", ">", 0)
					.orderBy("Errors", "desc")
					.orderBy("DateUpdated", "desc");

			let query = conversationsRef.limit(limit);

			// For pages beyond the first, fetch the starting point
			if (page > 1) {
				const offset = (page - 1) * limit;
		
				// Get the last document of the previous page
				const snapshot = await conversationsRef.limit(offset).get();
		
				if (!snapshot.empty) {
					const lastDoc = snapshot.docs[snapshot.docs.length - 1];
					query = conversationsRef.startAfter(lastDoc).limit(limit);
				} else {
					throw new Error("No data found for the requested page.");
				}
			}
			return bindFirestoreRef('convos', query);
		}),
		needHumanFeedbackConvos: firestoreAction(async ({ bindFirestoreRef }, { uid, limit, page }) => {
			if (!uid) {
				throw new Error("UID is required for needHumanFeedbackConvos");
			}
			const conversationsRef = db.collection("Conversations")
					.where("Uid", "==", uid)
					.where("needHumanFeedback", "==", true)
					.orderBy("needHumanFeedback", "desc")
					.orderBy("DateUpdated", "desc");

			let query = conversationsRef.limit(limit);

			// For pages beyond the first, fetch the starting point
			if (page > 1) {
				const offset = (page - 1) * limit;
		
				// Get the last document of the previous page
				const snapshot = await conversationsRef.limit(offset).get();
		
				if (!snapshot.empty) {
					const lastDoc = snapshot.docs[snapshot.docs.length - 1];
					query = conversationsRef.startAfter(lastDoc).limit(limit);
				} else {
					throw new Error("No data found for the requested page.");
				}
			}
			return bindFirestoreRef('convos', query);
		}),
		unreadConvos: firestoreAction(async ({ bindFirestoreRef }, { uid, limit, page }) => {
			if (!uid) {
				throw new Error("UID is required for scheduledConvos");
			}
			const conversationsRef = db.collection("Conversations")
					.where("Uid", "==", uid)
					.where("Unread", ">", 0)
					.orderBy("Unread", "desc")
					.orderBy("DateUpdated", "desc");

			let query = conversationsRef.limit(limit);

			// For pages beyond the first, fetch the starting point
			if (page > 1) {
				const offset = (page - 1) * limit;
		
				// Get the last document of the previous page
				const snapshot = await conversationsRef.limit(offset).get();
		
				if (!snapshot.empty) {
					const lastDoc = snapshot.docs[snapshot.docs.length - 1];
					query = conversationsRef.startAfter(lastDoc).limit(limit);
				} else {
					throw new Error("No data found for the requested page.");
				}
			}
			return bindFirestoreRef('convos', query);
		}),
		autopilotConvos: firestoreAction(async ({ bindFirestoreRef }, { uid, limit, page }) => {
			if (!uid) {
				throw new Error("UID is required for autopilotConvos");
			}
			const conversationsRef = db.collection("Conversations")
					.where("Uid", "==", uid)
					.where("autoSms", "==", true)
					.orderBy("autoSms", "desc")
					.orderBy("DateUpdated", "desc");

			let query = conversationsRef.limit(limit);

			// For pages beyond the first, fetch the starting point
			if (page > 1) {
				const offset = (page - 1) * limit;
		
				// Get the last document of the previous page
				const snapshot = await conversationsRef.limit(offset).get();
		
				if (!snapshot.empty) {
					const lastDoc = snapshot.docs[snapshot.docs.length - 1];
					query = conversationsRef.startAfter(lastDoc).limit(limit);
				} else {
					throw new Error("No data found for the requested page.");
				}
			}
			return bindFirestoreRef('convos', query);
		}),
		scheduledConvos: firestoreAction(async ({ bindFirestoreRef }, { uid, limit, page }) => {
			if (!uid) {
				throw new Error("UID is required for scheduledConvos");
			}
			const conversationsRef = db.collection("Conversations")
				.where('Uid', '==', uid)
				.where('ScheduledCount', '>', 0)
				.orderBy('ScheduledCount', 'desc')
				.orderBy('DateUpdated', 'desc');

			let query = conversationsRef.limit(limit);

			// For pages beyond the first, fetch the starting point
			if (page > 1) {
				const offset = (page - 1) * limit;
		
				// Get the last document of the previous page
				const snapshot = await conversationsRef.limit(offset).get();
		
				if (!snapshot.empty) {
					const lastDoc = snapshot.docs[snapshot.docs.length - 1];
					query = conversationsRef.startAfter(lastDoc).limit(limit);
				} else {
					throw new Error("No data found for the requested page.");
				}
			}
			return bindFirestoreRef('convos', query);
		}),

		rebindProspectsNew: firestoreAction(async ({ dispatch, bindFirestoreRef }, uid) => {
			return db.collection('Users').where('Uid', '==', uid).get().then(querySnap => {
				querySnap.docs[0].ref.get().then( docSnap => {
					dispatch('fetchFcmToken', {user: docSnap.data(), id: docSnap.id});
					});
					let pid = querySnap.docs[0].id;

				let p2 = bindFirestoreRef('prospects', db.collection(`Users/${pid}/Prospects`));
				return Promise.all([p2]);
			})
		}),

		// rebindEmails: firestoreAction(({ bindFirestoreRef }, uid) => {
		// 	let p6 = bindFirestoreRef('emails', db.collection('Emails').where('Uid', '==', uid));
		// 	return Promise.all([p6]);
		// }),

		rebindEmails: firestoreAction(({ bindFirestoreRef }, uid) => {
			let p6 = bindFirestoreRef('emails', db.collection('Emails')
				.where('Uid', '==', uid));
			return Promise.all([p6]);
		}),

		// rebindCalls: firestoreAction(({ bindFirestoreRef }, uid) => {
		// 	let p8 = bindFirestoreRef('calls', db.collection('Calls')
		// 	.where('Uid', '==', uid));
		// 	return Promise.all([p8]);
		// }),
		// rebindCampaigns: firestoreAction(({ bindFirestoreRef }, pid) => {
		// 	return bindFirestoreRef('campaigns', db.collection(`Users/${pid}/Campaigns`));
		// }),

		bindMessages: firestoreAction(({ bindFirestoreRef }, convoId) => {
			return bindFirestoreRef('messages', db.collection(`Conversations/${convoId}/Messages`).orderBy('Date', 'desc'));
			// return bindFirestoreRef('messages', db.collection(`Conversations/${convoId}/Messages`).orderBy('Date', 'desc'));
		}),
		bindGroupMessages: firestoreAction(({ bindFirestoreRef }, grpconvoId) => {
			return bindFirestoreRef('grpmessages', db.collection(`Conversations_v2/${grpconvoId}/Messages`).orderBy('Date', 'desc'));

			// return bindFirestoreRef('messages', db.collection(`Conversations/${convoId}/Messages`).orderBy('Date', 'desc'));
		}),
		bindMails: firestoreAction(({ bindFirestoreRef }, mailId) => {
			let mailList = [];
			if  (mailId) {
				mailList = db.collection(`Emails/${mailId}/Mails`).orderBy('Date', 'desc').limit(100);
			}
			return bindFirestoreRef('mails', mailList);
		}),

		bindPhones: firestoreAction(({ bindFirestoreRef }, callId) => {
			let callList = [];
			if  (callId) {
				callList = db.collection(`Calls/${callId}/Phones`).orderBy('Date', 'desc').limit(100);
			}
			return bindFirestoreRef('phones', callList);
		}),

		bindUserData: firestoreAction(async ({ dispatch, bindFirestoreRef }, uid) => {
			return db.collection('Users').where('Uid', '==', uid).get().then(querySnap => {
				querySnap.docs[0].ref.get().then( docSnap => {
					dispatch('fetchFcmToken', {user: docSnap.data(), id: docSnap.id});
				});
				let pid = querySnap.docs[0].id;
				let p1 = bindFirestoreRef('user', db.doc(`Users/${pid}`));
				// let p2 = bindFirestoreRef('prospects', db.collection(`Users/${pid}/Prospects`));
				let p3 = bindFirestoreRef('campaigns', db.collection(`Users/${pid}/Campaigns`));
				//let p4 = bindFirestoreRef('convos', db.collection('Conversations')
				//.where('Uid', '==', uid).orderBy('DateUpdated', 'desc').limit(3));
				let p7 = bindFirestoreRef('groupconvos', db.collection('Conversations_v2')
					.where('Uid', '==', uid).orderBy('DateUpdated', 'desc'));

				let p5 = bindFirestoreRef('teams', db.doc(`Team/zzxOvpZGle9GsNlZqisB`));

				// let p6 = bindFirestoreRef('emails', db.collection('Emails').where('Uid', '==', uid).limit(3));
				let p8 = bindFirestoreRef('calls', db.collection('Calls').where('Uid', '==', uid));
				return Promise.all([p1, p3, p5, p7, p8]);
			})
		}),
		bindAdminData: firestoreAction(({ bindFirestoreRef }, uid) => {
			return db.collection('Users').where('Uid', '==', uid).get().then(querySnap => {
				let pid = querySnap.docs[0].id;
				let p1 = bindFirestoreRef('user', db.doc(`Users/${pid}`));
				let p2 = bindFirestoreRef('convos', db.collection('Conversations')
					.orderBy('DateUpdated', 'desc').limit(100));

				// let p3 = bindFirestoreRef('emails', db.collection('Emails')
				// 	.orderBy('DateUpdated', 'desc').limit(100));
				return Promise.all([p1, p2]);
			})
		}),
		clearBoundData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('campaigns');
			unbindFirestoreRef('prospects');
			unbindFirestoreRef('messages');
			unbindFirestoreRef('convos');
			unbindFirestoreRef('groupconvos');
			unbindFirestoreRef('user');
			unbindFirestoreRef('teams');
			unbindFirestoreRef('emails');
			unbindFirestoreRef('calls');
			unbindFirestoreRef('mails');
			unbindFirestoreRef('phones');
			unbindFirestoreRef('grpmessages');
			commit('CLEAR_ALL');
		}),
		clearMailsData: firestoreAction(({ commit, unbindFirestoreRef }) => {

			unbindFirestoreRef('emails');
			unbindFirestoreRef('mails');
			commit('CLEAR_MAILS');
		}),

		clearonlyMailsData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('mails');
			commit('CLEAR_ONLY_MAILS');
		}),

		clearCallsData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('calls');
			unbindFirestoreRef('phones');
			commit('CLEAR_CALLS');
		}),

		clearonlyPhonesData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('phones');
			commit('CLEAR_ONLY_PHONES');
		}),
		clearConvoData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('convos');
			commit('CLEAR_ONLY_CONVO');
		}),
		clearProsData: firestoreAction(({ commit, unbindFirestoreRef }) => {
			unbindFirestoreRef('prospects');
			commit('CLEAR_ONLY_PROSPECT');
		})
	}
}
